import { useStorage } from "../storage";
import { useCallback, useMemo } from "react";
import { defined } from "../utils";
export function useDataTableColumnStorage(key, availableColumns) {
    const defaultColumns = useMemo(() => availableColumns
        .filter(c => c.default)
        .map(c => c.field), [availableColumns]);
    const [storage, setStorage] = useStorage(key, defaultColumns);
    const columns = storage
        .map(c => availableColumns.find(a => a.field == c))
        .filter(defined);
    const setColumns = useCallback((columns) => {
        setStorage(columns.map(c => c.field));
    }, []);
    return {
        columns,
        setColumns
    };
}
//# sourceMappingURL=useDataTableColumnStorage.js.map